import { render, staticRenderFns } from "./SessionDurationDialog.vue?vue&type=template&id=2b046310&"
import script from "./SessionDurationDialog.vue?vue&type=script&lang=js&"
export * from "./SessionDurationDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports